import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetTitleAudioV2Response } from './get-title-audio-v2-response';
import { getTitleAudioV2ResponseSchema } from './get-title-audio-v2-response';

export async function getTitleAudioV2Api(
  slug: string,
): Promise<IValidatedResponse<IGetTitleAudioV2Response>> {
  return getRequest<IGetTitleAudioV2Response>({
    path: `/challenges/${slug}/audio/v2/title`,
    schema: getTitleAudioV2ResponseSchema,
  });
}
